var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ce0024;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.099 -0.209)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0.099 0.209)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.756 17.83)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M231.566,735.17a4.524,4.524,0,0,0-4.524-4.524H215.308a4.525,4.525,0,0,0-4.524,4.524v5.5a4.524,4.524,0,0,0,4.524,4.524h11.734a4.524,4.524,0,0,0,4.524-4.524Zm-7.4,3.027-4.68,2.566c-.2.11-.387-.037-.387-.268v-5.269c0-.234.189-.381.392-.265l4.712,2.7A.306.306,0,0,1,224.163,738.2Z",
    transform: "translate(-210.784 -730.646)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeicon);
export default __webpack_public_path__ + "static/media/youtubeicon.d81c31bc03f5edd0e70de0ab6393f856.svg";
export { ForwardRef as ReactComponent };